export { default } from 'shared/components/context/container'
